import { fetchAdminList } from '@/api/base/index';

const GET_ADMINS_LIST = 'GET_ADMINS_LIST';
const FETCH_STATE = 'FETCH_STATE';

const state = () => ({
  list: [],
  fetching: false,
});

const getters = {
  AdminList: state => state.list,
};

const actions = {
  fetchAdminList({ state, commit }) {
    if (state.fetching) return;
    commit(FETCH_STATE, true);
    return fetchAdminList().then(res => {
      const list = res.data;
      commit(GET_ADMINS_LIST, list);
      commit(FETCH_STATE, false);
    });
  },
};

const mutations = {
  [GET_ADMINS_LIST](state, list) {
    state.list = list;
  },
  [FETCH_STATE](state, fetching) {
    state.fetching = fetching;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
